import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { orderTakeaway } from '../models/Takeaway';
import { CheckOutResult } from 'src/app/shared/check-out/CheckOut.models';

@Injectable({
  providedIn: 'root'
})
export class TakeawayOrderService {
  checkoutIdsSaver = new BehaviorSubject<string[]>([]);

  constructor(private http: HttpClient) { }

  ResCreateTakeawayOrder(data: orderTakeaway) {
    return this.http.post<CheckOutResult>(`${environment.apiUrl}/ResReservationOrderTakeaway/ResCreateTakeawayOrder`, data);
  }
  ResTakeawayGetCheckoutId(data: any) {
    return this.http.post<any>(`${environment.apiUrl}/ResReservationOrderTakeaway/ResTakeawayGetCheckoutId`, data);
  }
  ResTakeawayGetNFCSDK(data: any) {
    return this.http.post<any>(`${environment.apiUrl}/ResReservationOrderTakeaway/ResTakeawayGetNFCSDK`, data);
  }
  ResGetCheckoutStatus(CheckoutId: any, isCheck = false) {
    return this.http.get<CheckOutResult>(`${environment.apiUrl}/ResReservationOrderTakeaway/ResTakeawayGetCheckoutStatus?CheckoutId=${CheckoutId}&isCheck=${isCheck}`);
  }
  GetTakeawayDiscountList(data: orderTakeaway) {
    return this.http.post(`${environment.apiUrl}/ResReservationOrderTakeaway/GetTakeawayDiscountList`, data);
  }

  ResFloorsList(restaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResReservation/ResFloorsList?restaurantId=${restaurantId}`);
  }
  ResFloorsChangeTakeAwayTable(restaurantId: number, floorId: number) {
    return this.http.get(`${environment.apiUrl}/ResReservationOrderTakeaway/ResFloorsChangeTakeAwayTable?RestaurantsId=${restaurantId}&floorId=${floorId}`);
  }
  ResCheckTakeAwayChangeTable(data: any) {
    return this.http.post(`${environment.apiUrl}/ResReservationOrderTakeaway/ResCheckTakeAwayChangeTable`, data);
  }
  ResCheckVoucherDiscount(data: any) {
    return this.http.post(`${environment.apiUrl}/ResReservationOrderTakeaway/ResCheckVoucherDiscount`, data);
  }
  ResTakeAwayOrderPermissions(restaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResReservationOrderTakeaway/ResTakeAwayOrderPermissions?restaurantId=${restaurantId}`);
  }
}
